<kendo-grid #rejectMasterGrid [kendoGridBinding]="gridData" [scrollable]="'true'" [resizable]="true" [sortable]="true"
  [pageable]="true" id="adjustment-expand-grid" [pageSize]="gridState.take" [skip]="gridState.skip" [navigable]="true"
  [sort]="gridState.sort" [filter]="filter" [selectable]="selectableSettings"
  (selectionChange)="onSelectionChange($event)" [rowSelected]="isRowSelected">
  <!-- TOOLBAR TEMPLATE -->
  <ng-template kendoGridToolbarTemplate>
    <div class="row bottom-margin-0">
      <div class="col m8 l8 xl6 margin-5 width-100p">
        <!-- MOVE RECORD -->
        <button class="btn btn-fullwidth background-red" id="add-record-btn" [disabled]="!isActionBtnDisabled"
          (click)="moveRejectedAdjustments()">
          Move To Adjustment
        </button>
        <!-- DELETE RECORD -->
        <button kendoButton class="btn btn-fullwidth background-red left-margin-5" [disabled]="!isActionBtnDisabled"
          (click)="deleteRejectedAdjustments()">Delete</button>
      </div>
    </div>
  </ng-template>

  <!-- MOBILE VIEW -->
  <kendo-grid-column media="(max-width: 772.98px)" title="Details">
    <ng-template kendoGridCellTemplate let-dataItem>
      <dl>
        <dd>
          <div class="align-left">
            <span class="bold">SSN4: </span>
            <span> {{ dataItem.lastFourSSN }}</span>
          </div>
        </dd>
        <dd>
          <div class="align-left">
            <span class="bold">Last Name: </span>
            <span> {{ dataItem.lastName }}</span>
          </div>
        </dd>
        <dd>
          <div class="align-left">
            <span class="bold">Fiscal Year: </span>
            <span> {{ dataItem.fiscalYear }}</span>
          </div>
        </dd>
        <dd>
          <div class="align-left">
            <span class="bold">PPED: </span>
            <span> {{ dataItem.payPeriodEndDate | date: 'MM/dd/yyyy'}}</span>
          </div>
        </dd>
        <dd>
          <div class="align-left">
            <span class="bold">Contribution: </span>
            <span [ngClass]=" 0 > dataItem.employeeContribution ? 'neg-amount' : ''">
              {{ dataItem.formatAmount}}</span>
          </div>
        </dd>
        <dd>
          <div class="align-left">
            <span class="bold">HW: </span>
            <span> {{ dataItem.hoursWorked}}</span>
          </div>
        </dd>
        <dd>
          <div class="align-left">
            <span class="bold">SH: </span>
            <span> {{ dataItem.standardHours}}</span>
          </div>
        </dd>
        <dd>
          <div class="align-left">
            <span class="bold">PCT: </span>
            <span> {{ dataItem.percentFullTime}}</span>
          </div>
        </dd>
        <dd>
          <div class="align-left">
            <span class="bold">AAComp: </span>
            <span> {{ dataItem.actualAnnualCompensation | currency:'USD':'symbol':'1.0-2'}}</span>
          </div>
        </dd>
        <dd>
          <div class="align-left">
            <span class="bold">AEComp: </span>
            <span> {{ dataItem.actualEarnableCompensation | currency:'USD':'symbol':'1.0-2'}}</span>
          </div>
        </dd>
        <dd>
          <div class="align-left">
            <span class="bold">Reason Code: </span>
            <span> {{ dataItem.reasonCodes}}</span>
          </div>
        </dd>
        <dd>
          <div class="align-left">
            <span class="bold">Warning: </span>
            <span class="text-warning" *ngIf="dataItem.issue" title={{dataItem.issue}}><span
                class="k-icon k-i-warning text-warning"></span></span>
          </div>
        </dd>
      </dl>
    </ng-template>
  </kendo-grid-column>

  <!-- CHILD CHECK BOX -->
  <kendo-grid-checkbox-column showSelectAll="true" class="chkbox align-center" [width]="40">
    <!-- // ENABLE AFTER BOO CONFIRMATION -->
    <!-- <ng-template kendoGridHeaderTemplate let-idx="rowIndex" let-dataItem>
      <div class="align-center">
        <input class="k-checkbox" type="checkbox" kendoGridSelectAllCheckbox id="selectAllValidChildCheckboxId">
        <label class="k-checkbox-label" for="selectAllValidChildCheckboxId"></label>
      </div>
    </ng-template> -->
    <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
      <div class="align-center">
        <input [kendoGridSelectionCheckbox]="idx" class="k-checkbox" type="checkbox" id="{{'rejectChk'+idx}}" />
        <label class="k-checkbox-label" for="{{'rejectChk'+idx}}"></label>
      </div>
    </ng-template>
  </kendo-grid-checkbox-column>

  <!-- ADJUSTMENT ID -->
  <kendo-grid-column field="payrollAdjustmentsId" title="Adj ID" [width]="80">
  </kendo-grid-column>

  <!-- SSN COLUMN -->
  <kendo-grid-column media="(min-width: 773px)" field="lastFourSSN" [headerClass]="{'align-center': true}"
    class="align-center" title="SSN4" [width]="80">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <div class="align-center">
        {{dataItem.lastFourSSN}}
      </div>
    </ng-template>
  </kendo-grid-column>

  <!-- LAST NAME -->
  <kendo-grid-column media="(min-width: 773px)" field="lastName" title="Last Name" [width]="100">
  </kendo-grid-column>

  <!-- FISCAL YEAR -->
  <!-- <kendo-grid-column media="(min-width: 773px)" field="fiscalYear" title="Fiscal Year" [width]="100"
    [headerClass]="{'align-date': true}">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="align-date">
        <span>
          {{dataItem.fiscalYear}}
        </span>
      </div>
    </ng-template>
  </kendo-grid-column> -->

  <!-- PPED -->
  <kendo-grid-column media="(min-width: 773px)" field="payPeriodEndDate" title="PPED" [width]="100"
    [headerClass]="{'align-date': true}">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="align-date">
        {{dataItem.payPeriodEndDate | date: 'MM/dd/yyyy'}}
        <!-- TODO: after BOO discussion -->
        <!-- <a (click)="openRecord(dataItem, true)" class="clone-link">
          {{dataItem.payPeriodEndDate | date: 'MM/dd/yyyy'}}
        </a> -->
      </div>
    </ng-template>
  </kendo-grid-column>

  <!-- EMP CONTRIBUTION -->
  <kendo-grid-column media="(min-width: 773px)" field="employeeContribution" title="Contribution" [width]="110"
    [headerClass]="{'align-number': true}">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="align-number">
        <span [ngClass]=" 0 > dataItem.employeeContribution ? 'neg-amount' : ''">
          {{dataItem.formatAmount}}
        </span>
      </div>
    </ng-template>
  </kendo-grid-column>

  <!-- HOURS WORKED -->
  <kendo-grid-column media="(min-width: 773px)" field="hoursWorked" title="HW" [width]="60" format="{0:n1}"
    [headerClass]="{'align-number': true}" class="align-number"></kendo-grid-column>

  <!-- STANDARD HOURS -->
  <kendo-grid-column media="(min-width: 773px)" field="standardHours" title="SH" [width]="60" format="{0:n1}"
    [headerClass]="{'align-number': true}" class="align-number"></kendo-grid-column>

  <!-- PCT -->
  <kendo-grid-column media="(min-width: 773px)" field="percentFullTime" title="PCT" [width]="60" format="{0:n0}"
    [headerClass]="{'align-number': true}" class="align-number"></kendo-grid-column>

  <!-- AAC -->
  <kendo-grid-column media="(min-width: 773px)" field="actualAnnualCompensation" title="AAComp" [width]="100"
    [headerClass]="{'align-number': true}">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="align-number">{{dataItem.actualAnnualCompensation | currency:'USD':'symbol':'1.0-2'}}</div>
    </ng-template>
  </kendo-grid-column>

  <!-- AEC -->
  <kendo-grid-column media="(min-width: 773px)" field="actualEarnableCompensation" title="AEComp" [width]="100"
    [headerClass]="{'align-number': true}">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="align-number">{{dataItem.actualEarnableCompensation | currency:'USD':'symbol':'1.0-2'}}</div>
    </ng-template>
  </kendo-grid-column>

  <!-- COMMENT -->
  <kendo-grid-command-column media="(min-width: 773px)" field="comments" title="Comment"
    [headerClass]="{'align-center': true}" [width]="100">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="align-center">
        <button kendoButton type="button" [disabled]="dataItem.comments === null"
          [ngClass]="dataItem.comments === null ? 'comment-btn background-red border-red' : 'background-green'"
          (click)="openCommentDialog(dataItem)" [primary]="dataItem.comments === null ? true : false"><span
            class="k-icon k-i-comment border-white"></span></button>
      </div>
    </ng-template>
  </kendo-grid-command-column>
  <div *ngIf="isClicked">
    <app-record-detail-view [adjRecordDetail]="adjRecord" (isCancelClicked)="isDialogClosed($event)">
    </app-record-detail-view>
  </div>
</kendo-grid>
<app-notification-loading></app-notification-loading>

<kendo-dialog class="app-dialog" *ngIf="adjCommentDialog" [minWidth]="350" id="adj-action-dialog"
  (close)="closeCommentDialog()">
  <kendo-dialog-titlebar>Comment</kendo-dialog-titlebar>
  <div>
    <div class="textarea-wrapper">
      <p>{{textAreaValue}}</p>
    </div>
  </div>
  <kendo-dialog-actions>
    <button kendoButton class="k-button" id="comment-action" (click)="closeCommentDialog()">Cancel</button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog title="Delete Adjustment(s)" class="app-dialog" *ngIf="adjDeleteDialog" [minWidth]="250"
  id="adj-delete-dialog" (close)="deleteAdj('no')">
  <div>
    <p>Do you want to permanently delete <span class="bold">{{selectedData.length}}</span> adjustment(s)?</p>
  </div>
  <kendo-dialog-actions>
    <button kendoButton class="k-button" [disabled]="loading" (click)="deleteAdj('no')" primary="true">No</button>
    <button kendoButton class="k-button" [disabled]="loading" (click)="deleteAdj('yes')" primary="true">
      <span *ngIf="!loading">Yes</span>
      <span *ngIf="loading" class="k-icon k-i-loading inner"></span>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog title="Move Adjustment(s)" class="app-dialog" *ngIf="adjMoveDialog" [minWidth]="250" id="adj-move-dialog"
  (close)="moveAdj('no')">
  <div class="top-margin-20">
    <label class="bold">Select Adjustment:</label>
    <kendo-dropdownlist id="ddlOrgSelect" class="left-margin-30" [data]="filteredNotSubmittedAdj" [textField]="'id'"
      [valueField]="'id'" [(ngModel)]="defaultNotsubmittedAdj" [filterable]="true" [defaultItem]="defaultItem"
      [popupSettings]="{ popupClass: 'nova-font-style text-black' }" (filterChange)="handleFilter($event)">
    </kendo-dropdownlist>
  </div>
  <kendo-dialog-actions>
    <button kendoButton class="k-button" [disabled]="loading" (click)="moveAdj('no')" primary="true">Cancel</button>
    <button kendoButton class="k-button" [disabled]="loading" (click)="moveAdj('yes')" primary="true">
      <span *ngIf="!loading">Move</span>
      <span *ngIf="loading" class="k-icon k-i-loading inner"></span>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
